<template>
  <div>
    <h2>Ativos</h2>

    <v-data-table
      :headers="headers"
      :items="data"
      :page.sync="page"
      :sort-by.sync="sortBy"
      :items-per-page="perPage"
      :loading="isLoading"
      hide-default-footer
      disable-sort
      class="elevation-1"
    >
      <template v-slot:top>
        <v-toolbar flat>
          <v-text-field
            v-model="searchFilter.query"
            append-icon="mdi-magnify"
            label="Pesquisar"
            single-line
            hide-details
            clearable
          ></v-text-field>
          <v-spacer></v-spacer>
          <v-dialog v-model="dialogForm" max-width="940px">
            <template
              v-slot:activator="{ on, attrs }"
              v-if="permissions['create_assets']"
            >
              <v-btn
                outlined
                color="#0dc4b8"
                class="mb-2"
                v-bind="attrs"
                v-on="on"
              >
                Novo Ativo
              </v-btn>
            </template>
            <AssetsForm
              v-if="dialogForm"
              :selectedIndex="selectedIndex"
              :selectedData="selectedItem"
              :filesActivesProps="filesActives"
              v-on:onClose="closeFormModal"
              v-on:onSubmit="
                closeFormModal();
                loadData();
              "
            />
          </v-dialog>

          <v-dialog v-model="dialogDelete" max-width="500px">
            <v-card>
              <v-card-title class="headline center"
                >Deseja realmente excluir {{ selectedItem.code }} -
                {{ selectedItem.description }} ?
              </v-card-title>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="#0dc4b8" text @click="closeDeleteModal"
                  >Cancelar
                </v-btn>
                <v-btn
                  color="#0dc4b8"
                  text
                  @click="deleteItemConfirm"
                  :disabled="
                    isLoading ||
                    ['Administrador', 'Cliente'].includes(selectedItem.name)
                  "
                  :loading="isLoading"
                  >OK
                </v-btn>
                <v-spacer></v-spacer>
              </v-card-actions>
            </v-card>
          </v-dialog>

          <v-dialog v-model="dialogGenerate" max-width="940px">
            <v-card>
              <v-card-title class="headline center">Gerar Tokens</v-card-title>

              <v-container>
                <v-row>
                  <v-col cols="12" sm="12" md="12">
                    <v-text-field
                      :value="
                        selectedItem.checkbox
                          ? selectedItem.amount_token
                          : 'Sem quantidade máxima limitada'
                      "
                      label="Quantidade máxima de tokens"
                      disabled
                    ></v-text-field>
                  </v-col>
                </v-row>

                <v-row>
                  <v-col cols="12" sm="12" md="12">
                    <v-text-field
                      label="Lote"
                      required
                      hide-details="auto"
                      type="number"
                      v-model="selectedItem.total_lote"
                      disabled
                    ></v-text-field>
                  </v-col>
                </v-row>

                <v-row>
                  <v-select
                    v-model.lazy="typeDocs"
                    :items="arrayDoc"
                    item-text="docs"
                    item-value="id"
                    label="Documentos"
                    multiple
                  ></v-select>
                </v-row>

                <v-row>
                  <v-list flat>
                    <v-subheader>Tokens por documento</v-subheader>
                    <v-list-item-group>
                      <v-list-item
                        v-for="(item, index) in arrayDocselect"
                        :key="index"
                      >
                        <v-list-item-content>
                          <v-list-item-title
                            v-text="
                              item.docs +
                              ' >>  ' +
                              item.qtd +
                              ' tokens disponíveis'
                            "
                          ></v-list-item-title>
                        </v-list-item-content>
                      </v-list-item>
                    </v-list-item-group>
                  </v-list>
                </v-row>

                <v-row>
                  <v-col cols="6" sm="6" md="6">
                    <v-text-field
                      v-model="amount_token_generate"
                      label="Quantidade de tokens que serão gerados"
                      readonly
                      hide-details="auto"
                      type="number"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="6" sm="6" md="6">
                    <v-text-field
                      label="Token/Unidade"
                      readonly
                      hide-details="auto"
                      :value="
                        selectedItem.valorunidade +
                        ' ' +
                        selectedItem.unidades +
                        ' ' +
                        selectedItem.complement
                      "
                    ></v-text-field>
                  </v-col>

                  <!-- <v-col cols="6" sm="6" md="6" v-if="contains_carbon == true">
                    <v-text-field
                      v-model="amount_co2"
                      label="Tonelada CO2 por Token"
                      required
                      hide-details="auto"
                      type="number"
                    ></v-text-field>
                  </v-col> -->
                </v-row>
              </v-container>

              <v-container v-if="!isLoadingGenerate">
                <div style="min-height: 10px">
                  <v-progress-linear
                    v-model="value"
                    :active="show"
                    :indeterminate="query"
                    :query="true"
                  ></v-progress-linear>
                </div>
              </v-container>

              <v-card-actions v-if="isLoadingGenerate">
                <v-spacer></v-spacer>
                <v-btn color="#0dc4b8" text @click="closeGenerateModal"
                  >Cancelar
                </v-btn>
                <v-btn
                  color="#0dc4b8"
                  text
                  @click="generateItemConfirm"
                  :disabled="
                    isLoading ||
                    ['Administrador', 'Cliente'].includes(selectedItem.name)
                  "
                  :loading="isLoading"
                  >Gerar Tokens
                </v-btn>
                <v-spacer></v-spacer>
              </v-card-actions>
            </v-card>
          </v-dialog>

          <v-dialog v-model="dialogVisualiza" max-width="940px">
            <VisualModal
              v-if="dialogVisualiza"
              :selectedIndex="selectedIndex"
              :selectedData="selectedItem"
              v-on:onClose="closeVisualizaModal"
              v-on:onSubmit="
                closeVisualizaModal();
                loadData();
              "
            />
          </v-dialog>
        </v-toolbar>
      </template>

      <template
        v-slot:item.actions="{ item }"
        v-if="permissions['edit_assets']"
      >
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-btn icon :loading="isLoading">
              <v-icon
                dense
                @click="openEditItemModal(item)"
                v-bind="attrs"
                v-on="on"
              >
                mdi-pencil
              </v-icon>
            </v-btn>
          </template>
          <span>Editar</span>
        </v-tooltip>

        <v-tooltip bottom>
          <template
            v-slot:activator="{ on, attrs }"
            v-if="permissions['delete_assets']"
          >
            <v-icon
              dense
              @click="openDeleteItemModal(item)"
              v-bind="attrs"
              v-on="on"
            >
              mdi-delete
            </v-icon>
          </template>
          <span>Excluir</span>
        </v-tooltip>

        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-btn icon :loading="isLoading">
              <v-icon
                dense
                @click="RedirectDocs(item)"
                v-bind="attrs"
                v-on="on"
              >
                mdi-text-box-plus
              </v-icon>
            </v-btn>
          </template>
          <span>Documentos</span>
        </v-tooltip>

        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-btn icon :loading="isLoading">
              <v-icon
                dense
                @click="openGenerateTokenModal(item)"
                v-bind="attrs"
                v-on="on"
              >
                mdi-content-save-move-outline
              </v-icon>
            </v-btn>
          </template>
          <span>Gerar Token</span>
        </v-tooltip>

        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-btn icon :loading="isLoading">
              <v-icon
                dense
                @click="
                  $router.push({
                    name: 'assets.show',
                    params: { code: item.code },
                  })
                "
                v-bind="attrs"
                v-on="on"
              >
                mdi-eye-settings
              </v-icon>
            </v-btn>
          </template>
          <span>Visualizar Tokens</span>
        </v-tooltip>

        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-btn icon :loading="isLoading">
              <v-icon
                dense
                @click="
                  $router.push({
                    name: 'assets.replacement',
                    params: { code: item.code },
                  })
                "
                v-bind="attrs"
                v-on="on"
              >
                mdi-archive-refresh-outline
              </v-icon>
            </v-btn>
          </template>
          <span>Substituir Tokens</span>
        </v-tooltip>

        <!-- <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-btn icon :loading="isLoading">
              <v-icon
                dense
                @click="openGenerateTokenModal(item)"
                v-bind="attrs"
                v-on="on"
              >
                mdi-format-list-bulleted
              </v-icon>
            </v-btn>
          </template>
          <span>Ver documentos</span>
        </v-tooltip> -->
      </template>

      <template v-slot:footer>
        <div class="table-footer">
          <span class="mr-4" v-if="total > 0"
            >Exibindo {{ from }} - {{ to }} de {{ total }}
          </span>
        </div>
      </template>
    </v-data-table>

    <div class="text-center pt-2">
      <v-pagination v-model="page" :length="totalPages"></v-pagination>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex';
import AssetsForm from './_form.vue';
import VisualModal from './_visualtoken.vue';
import Api from '../../services/api.service';
import routers from '../../router/index';

export default {
  name: 'Assets',
  components: {
    AssetsForm,
    VisualModal,
  },
  data: () => ({
    data: [],
    arrayDoc: [],
    dialogForm: false,
    dialogDelete: false,
    dialogGenerate: false,
    dialogVisualiza: false,
    isLoadingGenerate: true,
    contains_carbon: false,
    from: 0,
    headers: [
      { text: 'Código', value: 'code' },
      { text: 'Nome do Token', value: 'name_token' },
    ],
    isLoading: true,
    page: 1,
    perPage: 500,
    searchFilter: {
      query: null,
    },
    selectedIndex: -1,
    selectedItem: {},
    filesActives: [],
    idEdit: 0,
    sortBy: 'assets.code',
    to: 0,
    total: 0,
    totalPages: 0,
    value: 0,
    query: false,
    show: true,
    interval: 0,
    amount_token_generate: 0,
    amount_co2: 0,
    typeDocs: null,
    arrayDuplicate: [],
    arrayDocselect: [],
  }),
  computed: {
    ...mapGetters(['permissions']),
  },
  watch: {
    dialogForm(val) {
      if (val && this.selectedIndex == -1 && this.$refs.form)
        this.$refs.form.resetValidation();
      val || this.closeFormModal();
    },
    dialogDelete(val) {
      val || this.closeDeleteModal();
    },
    page: function () {
      this.loadData();
    },
    searchFilter: {
      handler() {
        this.page = 1;
        this.loadData();
      },
      deep: true,
    },
    typeDocs: function (value) {
      this.amount_token_generate = 0;
      this.arrayDocselect = [];
      var qtd = 0;
      for (let i = 0; i < value.length; i++) {
        this.arrayDoc.map((e) => {
          if (e.id == value[i]) {
            qtd = e.qtd;
            this.arrayDocselect.push(e);
          }
        });
        this.amount_token_generate += qtd;
      }

      this.selectedItem.docs = value;
    },
  },
  mounted() {
    if (this.permissions['edit_assets'] || this.permissions['delete_assets']) {
      this.headers.push({ text: 'Ações', value: 'actions', sortable: false });
    }

    this.loadData();
  },
  methods: {
    ...mapMutations(['showSnackbar']),

    async queryAndIndeterminate() {
      this.query = true;
      this.show = true;
      this.value = 0;

      if (!this.amount_co2) {
        this.amount_co2 = 0;
      }

      const datagenerate = {
        lote: this.selectedItem.total_lote,
        amount_co2: this.amount_co2,
        activeId: this.selectedIndex,
        amount_token_generate: this.amount_token_generate,
        registrationId: this.selectedItem.docs,
      };
      this.isLoadingGenerate = false;
      try {
        await Api.post('generation-tokens', datagenerate);
        this.showSnackbar({
          text: 'Tokens estão sendo gerados com sucesso!',
          color: 'success',
        });
        this.isLoadingGenerate = true;
        this.amount_co2 = 0;
        this.amount_token_generate = 0;
      } catch {
        this.showSnackbar({
          text: 'Ops! Ocorreu um erro, tente novamente.',
          color: 'error',
        });
      } finally {
        this.isLoadingGenerate = true;
      }

      setTimeout(() => {
        this.query = false;
      }, 2500);

      setTimeout(() => {
        this.show = false;
        this.dialogGenerate = false;
        this.isLoadingGenerate = true;
      }, 40000);
    },

    clearForm() {
      this.selectedIndex = -1;
      this.selectedItem = {};
    },

    closeFormModal() {
      this.dialogForm = false;
      this.loadData();
      this.$nextTick(() => {
        this.clearForm();
      });
    },

    closeDeleteModal() {
      this.dialogDelete = false;
      this.$nextTick(() => {
        this.clearForm();
      });
    },

    closeGenerateModal() {
      this.dialogGenerate = false;
      this.amount_token_generate = 0;
      this.amount_co2 = 0;
    },

    closeVisualizaModal() {
      this.dialogVisualiza = false;
    },

    async deleteItemConfirm() {
      this.isLoading = true;
      try {
        await Api.delete(`actives/${this.selectedItem.code}`);
        this.loadData();
        this.showSnackbar({
          text: 'Ativo deletado com sucesso!',
          color: 'success',
        });
        this.closeDeleteModal();
      } catch {
        this.showSnackbar({
          text: 'Ops! Ocorreu um erro, tente novamente.',
          color: 'error',
        });
      } finally {
        this.isLoading = false;
      }
    },

    async loadData() {
      this.isLoading = true;

      try {
        const response = await Api.get('actives', {
          params: {
            page: this.page,
            per_page: this.perPage,
            search: this.searchFilter.query,
          },
        });

        console.log('RESPONSE FULL:', response);
        const apiResponse = response.data[0]; // Corrigido: acessa o array interno
        console.log('API RESPONSE DATA:', apiResponse);

        if (Array.isArray(apiResponse) && apiResponse.length > 0) {
          const arrayActives = apiResponse.map((item) => ({
            code: item.id,
            name_token: item.name_token,
            description: item.description || '',
            category: item.category_name,
            lotes: item.lotes || 0,
          }));

          this.data = arrayActives;
          this.total = apiResponse.length;
          this.from = 1;
          this.to = apiResponse.length;
          this.totalPages = 1; // Pode ajustar se o backend enviar paginação real depois
        } else {
          this.data = [];
          this.total = 0;
          this.from = 0;
          this.to = 0;
          this.totalPages = 0;
        }
      } catch (error) {
        console.error('Erro ao carregar dados:', error);
        this.showSnackbar({
          text: 'Ops! Houve um erro ao carregar os dados, tente novamente.',
          color: 'error',
        });
      } finally {
        this.isLoading = false;
      }
    },

    openDeleteItemModal(item) {
      this.selectedIndex = this.data.indexOf(item);
      this.selectedItem = Object.assign({}, item);
      this.dialogDelete = true;
    },

    RedirectDocs(item) {
      routers.push({
        name: 'registrationArea.index',
        params: { activeId: item },
      });
    },

    async openEditItemModal(item) {
      this.isLoading = true;
      const duplicate = this.arrayDuplicate.filter(
        ({ name_token }) => name_token == item.name_token
      );
      duplicate.push(item);
      try {
        const { data } = await Api.get(`actives/${item.code}`);
        this.selectedItem = {
          ...data.actives[0],
          subcategories: data.sucategories.map((el) => ({
            id: el.id,
            subcategory: el.name,
          })),
        };
        this.selectedItem.arrayDuplicate = duplicate;
        this.selectedIndex = item.code;
        this.filesActives = data.files_actives;

        setTimeout(() => {
          this.dialogForm = true;
        }, 11);
      } catch {
        this.showSnackbar({
          text: 'Ops! Houve um erro ao carregar os dados, tente novamente.',
          color: 'error',
        });
      } finally {
        this.isLoading = false;
      }
    },

    openGenerateTokenModal(item) {
      this.isLoading = true;

      Api.get(`actives/${item.code}`)
        .then((res) => {
          this.selectedItem = res.data.actives[0];

          this.selectedIndex = item.code;
          this.filesActives = res.data.files_actives;
          // this.amount_token_generate = res.data.actives[0].amount_token;
          this.amount_co2 = this.selectedItem.valorunidade;

          this.isLoading = false;
          this.containsCarbon(this.selectedItem.name_token);
          setTimeout(() => {
            this.dialogGenerate = true;
          }, 11);
        })
        .catch(() => {
          this.showSnackbar({
            text: 'Ops! Houve um erro ao carregar os dados, tente novamente.',
            color: 'error',
          });
          this.isLoading = false;
        });

      Api.get('registration')
        .then((res) => {
          var arrayDocs = [];
          res.data[0].map((items) => {
            if (items.active_id == item.code)
              arrayDocs.push({
                id: items.id,
                docs: items.name_registration,
                qtd: items.qtdvolume,
              });
          });

          this.arrayDoc = arrayDocs;
          this.isLoading = false;
        })
        .catch(() => {
          this.showSnackbar({
            text: 'Ops! Houve um erro ao carregar os dados, tente novamente.',
            color: 'error',
          });
          this.isLoading = false;
        });
    },

    async openVisualizaTokenModal(item) {
      this.isLoading = true;
      try {
        const {
          data: {
            actives: [active],
            files_actives,
          },
        } = Api.get(`actives/${item.code}`);
        this.selectedItem = active;
        this.selectedIndex = item.code;
        this.filesActives = files_actives;
        // this.amount_token_generate = res.data.actives[0].amount_token;
        this.amount_co2 = this.selectedItem.valorunidade;
        this.containsCarbon(this.selectedItem.name_token);
        setTimeout(() => {
          this.dialogVisualiza = true;
        }, 11);
      } catch {
        this.showSnackbar({
          text: 'Ops! Houve um erro ao carregar os dados, tente novamente.',
          color: 'error',
        });
      } finally {
        this.isLoading = false;
      }
    },

    containsCarbon(name) {
      this.contains_carbon = name.includes('CARBO') || name.includes('carbo');
    },
    generateItemConfirm() {
      if (
        this.selectedItem.checkbox &&
        this.amount_token_generate > this.selectedItem.amount_token
      ) {
        this.showSnackbar({
          text: 'A quantidade de tokens a gerar não pode ser maior que a quantidade total.',
          color: 'error',
        });

        return false;
      }

      if (this.amount_token_generate < 1) {
        this.showSnackbar({
          text: 'A quantidade de tokens a gerar não pode ser menor que 1.',
          color: 'error',
        });

        return false;
      }

      this.isLoadingGenerate = false;
      this.queryAndIndeterminate();
    },
  },
};
</script>
